import { colors } from "@/theme/colors";
import { IllustrationSvg } from "./IllustrationSvg";
import { Backdrop } from "./shapes";

/** Vertical centres of the three signed-off checklist rows. */
const ROWS = [56, 72, 88] as const;

/**
 * Flat illustration for the Scope step: a proposal sheet with a checked-off
 * deliverables list and a fixed-price tag — the package, agreed and signed.
 */
export function ScopeIllustration() {
  return (
    <IllustrationSvg>
      {/* Soft backdrop */}
      <Backdrop x={44} y={20} width={132} height={98} />
      {/* Proposal sheet */}
      <rect
        x="66"
        y="10"
        width="88"
        height="110"
        rx="10"
        fill={colors.paper}
        stroke={colors.divider}
        strokeWidth="2"
      />
      {/* Title block */}
      <rect
        x="78"
        y="22"
        width="46"
        height="9"
        rx="4.5"
        fill={colors.primary}
        opacity="0.85"
      />
      <rect
        x="78"
        y="36"
        width="64"
        height="5"
        rx="2.5"
        fill={colors.divider}
      />
      {/* Checked-off deliverable rows */}
      {ROWS.map((y) => (
        <g key={y}>
          <circle
            cx="84"
            cy={y}
            r="6.5"
            fill={colors.paper}
            stroke={colors.success}
            strokeWidth="1.5"
          />
          <path
            d={`M81 ${y} l2.2 2.4 l4.4 -5`}
            fill="none"
            stroke={colors.success}
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="96"
            y={y - 3}
            width="46"
            height="6"
            rx="3"
            fill={colors.divider}
          />
        </g>
      ))}
      {/* Fixed-price tag */}
      <rect
        x="78"
        y="102"
        width="42"
        height="12"
        rx="6"
        fill={colors.primary}
      />
      <rect
        x="84"
        y="106.5"
        width="18"
        height="3"
        rx="1.5"
        fill={colors.paper}
        opacity="0.85"
      />
    </IllustrationSvg>
  );
}
